// extracted by mini-css-extract-plugin
module.exports = {"editButton":"Edition_editButton__pFSoX"};